import { createContext } from "react"

const MiReportContext = createContext({})

const { Provider, Consumer } = MiReportContext

export { Provider, Consumer, MiReportContext }
